/**
 * 菜单
 */
const menuArray = [
    {
        name:"首页",
        routerName:"index",
        type:'simple',
        hide:false,
        modular: [
            {
                title: "工作站",
                menuList: [
                    {
                        iconIview: "ios-browsers",
                        name: "home",
                        title: "首页",
                        children: [],
                    },
                    {
                        iconIview: "ios-browsers",
                        name: "join-company-step",
                        title: "首页",
                        children: [],
                    },
                    {
                        iconIview: "md-time",
                        name: "unprocessed",
                        title: "待处理",
                        children: [],
                    },
                    {
                        iconIview: "md-stopwatch",
                        name: "urgentUnprocessed",
                        title: "紧急@待处理",
                        children: [],
                    },
                    {
                        iconIview:  "md-alarm",
                        name: "atUnprocessed",
                        title: "@待处理",
                        children: [],
                    },
                ],
            },
            {
                title: "快捷方式",
                menuList: [
                    {
                        iconAwesome: "fa-search",
                        name: "company-search",
                        title: "企业搜索",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-search",
                        name: "project-search",
                        title: "项目搜索",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-search",
                        name: "carrier-search",
                        title: "载体搜索",
                        children: [],
                    }
                ],
            }
        ]
    },
    {
        name:"项目管理",
        routerName:"item",
        type : "select",
        hide:false,
        children : [
            {
                title: "土地",
                routerName : 'land-item-all',
                menuList: [
                    {
                        iconIview: "md-apps",
                        name: "land-item-all",
                        title: "全部项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-pencil",
                        lastIconAwesome: "fa-plus",
                        name: "land-item-add",
                        title: "土地项目录入",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-star",
                        name: "land-item-focus",
                        title: "关注项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-flag",
                        name: "land-item-important",
                        title: "重点接洽项目",
                        children: [],
                    },
                    {
                        iconIview: "ios-clock",
                        name: "land-item-contacting",
                        title: "接洽中项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-pause-circle",
                        name: "land-item-pause",
                        title: "暂缓跟进项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-check-circle",
                        name: "land-item-success",
                        title: "成功项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-smile-o",
                        name: "land-item-allsuccess",
                        title: "全体成功项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-ship",
                        name: "land-item-sea",
                        title: "项目公海",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-trash",
                        name: "land-item-recycled",
                        title: "项目回收站",
                        children: [],
                    },
                ],

            },
            {
                title: "厂房",
                routerName : 'factory-item-all',
                menuList: [
                    {
                        iconIview: "md-apps",
                        name: "factory-item-all",
                        title: "全部项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-pencil",
                        lastIconAwesome: "fa-plus",
                        name: "factory-item-add",
                        title: "厂房项目录入",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-star",
                        name: "factory-item-focus",
                        title: "关注项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-flag",
                        name: "factory-item-important",
                        title: "重点接洽项目",
                        children: [],
                    },
                    {
                        iconIview: "ios-clock",
                        name: "factory-item-contacting",
                        title: "接洽中项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-pause-circle",
                        name: "factory-item-pause",
                        title: "暂缓跟进项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-check-circle",
                        name: "factory-item-success",
                        title: "成功项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-smile-o",
                        name: "factory-item-allsuccess",
                        title: "全体成功项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-ship",
                        name: "factory-item-sea",
                        title: "项目公海",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-trash",
                        name: "factory-item-recycled",
                        title: "项目回收站",
                        children: [],
                    },
                ]
            },
            {
                title: "仓库",
                routerName : 'warehouse-item-all',
                menuList: [
                    {
                        iconIview: "md-apps",
                        name: "warehouse-item-all",
                        title: "全部项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-pencil",
                        lastIconAwesome: "fa-plus",
                        name: "warehouse-item-add",
                        title: "仓库项目录入",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-star",
                        name: "warehouse-item-focus",
                        title: "关注项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-flag",
                        name: "warehouse-item-important",
                        title: "重点接洽项目",
                        children: [],
                    },
                    {
                        iconIview: "ios-clock",
                        name: "warehouse-item-contacting",
                        title: "接洽中项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-pause-circle",
                        name: "warehouse-item-pause",
                        title: "暂缓跟进项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-check-circle",
                        name: "warehouse-item-success",
                        title: "成功项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-smile-o",
                        name: "warehouse-item-allsuccess",
                        title: "全体成功项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-ship",
                        name: "warehouse-item-sea",
                        title: "项目公海",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-trash",
                        name: "warehouse-item-recycled",
                        title: "项目回收站",
                        children: [],
                    },
                ]
            },
            {
                title: "写字楼",
                routerName : 'officebuilding-item-all',
                menuList: [
                    {
                        iconIview: "md-apps",
                        name: "officebuilding-item-all",
                        title: "全部项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-pencil",
                        lastIconAwesome: "fa-plus",
                        name: "officebuilding-item-add",
                        title: "写字楼项目录入",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-star",
                        name: "officebuilding-item-focus",
                        title: "关注项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-flag",
                        name: "officebuilding-item-important",
                        title: "重点接洽项目",
                        children: [],
                    },
                    {
                        iconIview: "ios-clock",
                        name: "officebuilding-item-contacting",
                        title: "接洽中项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-pause-circle",
                        name: "officebuilding-item-pause",
                        title: "暂缓跟进项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-check-circle",
                        name: "officebuilding-item-success",
                        title: "成功项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-smile-o",
                        name: "officebuilding-item-allsuccess",
                        title: "全体成功项目",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-ship",
                        name: "officebuilding-item-sea",
                        title: "项目公海",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-trash",
                        name: "officebuilding-item-recycled",
                        title: "项目回收站",
                        children: [],
                    },
                ]
            },
        ]
    },
    {
        name:"载体管理",
        routerName:"carrier",
        type : "select",
        hide:false,
        children : [
            {
                title: "土地",
                routerName : 'land-carrier-all',
                menuList: [
                    {
                        iconIview: "md-apps",
                        name: "land-carrier-all",
                        title: "全部载体",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-pencil",
                        lastIconAwesome: "fa-plus",
                        name: "land-carrier-add",
                        title: "土地载体录入",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-star",
                        name: "land-carrier-focus",
                        title: "关注载体",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-trash",
                        name: "land-carrier-recycled",
                        title: "载体回收站",
                        children: [],
                    },
                ],
            },
            {
                title: "厂房",
                routerName : 'factory-carrier-all',
                menuList: [
                    {
                        iconIview: "md-apps",
                        name: "factory-carrier-all",
                        title: "全部载体",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-pencil",
                        lastIconAwesome: "fa-plus",
                        name: "factory-carrier-add",
                        title: "厂房载体录入",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-star",
                        name: "factory-carrier-focus",
                        title: "关注载体",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-trash",
                        name: "factory-carrier-recycled",
                        title: "载体回收站",
                        children: [],
                    },
                ],
            },
            {
                title: "仓库",
                routerName : 'warehouse-carrier-all',
                menuList: [
                    {
                        iconIview: "md-apps",
                        name: "warehouse-carrier-all",
                        title: "全部载体",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-pencil",
                        lastIconAwesome: "fa-plus",
                        name: "warehouse-carrier-add",
                        title: "仓库载体录入",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-star",
                        name: "warehouse-carrier-focus",
                        title: "关注载体",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-trash",
                        name: "warehouse-carrier-recycled",
                        title: "载体回收站",
                        children: [],
                    },
                ],
            },
            {
                title: "写字楼",
                routerName : 'officebuilding-carrier-all',
                menuList: [
                    {
                        iconIview: "md-apps",
                        name: "officebuilding-carrier-all",
                        title: "全部载体",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-pencil",
                        lastIconAwesome: "fa-plus",
                        name: "officebuilding-carrier-add",
                        title: "写字楼载体录入",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-star",
                        name: "officebuilding-carrier-focus",
                        title: "关注载体",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-trash",
                        name: "officebuilding-carrier-recycled",
                        title: "载体回收站",
                        children: [],
                    },
                ],
            }
        ]
    },
    {
        name:"单位",
        routerName:"company",
        hide:true,
        type : "simple",
        modular: [
            {
                title: "系统设置",
                menuList: [
                    {
                        iconAwesome: "fa-building",
                        name: "company-base-info",
                        title: "单位基本资料",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-user",
                        name: "company-member-info",
                        title: "单位成员",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-user-plus",
                        name: "company-member-more",
                        title: "添加单位成员",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-envelope",
                        name: "company-group",
                        title: "单位分组修改",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-tags",
                        name: "company-tag",
                        title: "标签管理",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-tasks",
                        name: "company-item",
                        title: "项目进度管理",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-tasks",
                        name: "company-carry",
                        title: "载体进度管理",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-file-o",
                        name: "company-file-config",
                        title: "项目附件管理",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-id-card",
                        name: "company-card-record",
                        title: "查看名片统计",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-map-o",
                        name: "company-administrative-area",
                        title: "行政区划管理",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-map-o",
                        name: "company-belong-area",
                        title: "所属区域管理",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-location-arrow",
                        name: "company-item-origin",
                        title: "项目来源管理",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-tag",
                        name: "company-profession-category",
                        title: "专业类别管理",
                        children: [],
                    },
                    // {
                    //     iconAwesome : "fa-map-pin",
                    //     name : "company-area-setting",
                    //     title : "企业区域管理",
                    //     children : [],
                    // }
                ],
            },
        ]
    },
    {
        name:"个人中心",
        routerName:"usercenter",
        hide:true,
        type : "simple",
        modular: [
            {
                title: "个人中心",
                menuList: [
                    {
                        iconAwesome: "fa-id-card-o",
                        name: "usercenter-info",
                        title: "个人信息",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-picture-o",
                        name: "usercenter-images",
                        title: "附件相机库",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-lock",
                        name: "usercenter-password",
                        title: "密码修改",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-list-alt",
                        name: "usercenter-business-cards",
                        title: "查看名片统计",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-envelope",
                        name: "usercenter-messages",
                        title: "消息列表",
                        children: [],
                    },
                ],
            },
        ]
    },
    {
        name:"企业管理",
        routerName:"enterprise",
        type : "simple",
        hide:false,
        modular : [
            {
                title: "企业管理",
                menuList: [
                    {
                        iconIview: "md-apps",
                        name: "enterprise-all",
                        title: "全部企业",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-pencil",
                        lastIconAwesome: "fa-plus",
                        name: "enterprise-add",
                        title: "企业录入",
                        children: [],
                    },
                    {
                        iconAwesome: "fa-star",
                        name: "enterprise-focus",
                        title: "关注企业",
                        children: [],
                    },
                    // {
                    //     iconAwesome: "fa-file-text",
                    //     name: "enterprise-report",
                    //     title: "企业报表",
                    //     children: [],
                    // },
                    // {
                    //     iconAwesome: "fa-stop-circle",
                    //     name: "enterprise-integral",
                    //     title: "企业积分",
                    //     children: [],
                    // },
                    {
                        iconAwesome: "fa-trash",
                        name: "enterprise-recycled",
                        title: "回收企业",
                        children: [],
                    },
                    // {
                    //     iconAwesome: "fa-users",
                    //     name: "enterprise-account",
                    //     title: "企业账户管理",
                    //     children: [],
                    // }
                ]
            }
        ]
    },
    {
        name:"数据管理",
        routerName:"datas",
        type : "simple",
        hide: false,
        modular: [
            {
                title: "数据",
                menuList: [
                    {
                        iconIview: "ios-speedometer",
                        name: "mydata",
                        title: "我的数据",
                        children: [],
                    },
                    {
                        iconIview: "ios-pie",
                        name: "overalldata",
                        title: "全局数据",
                        children: [],
                    },
                    // {
                    //     iconIview: "ios-flower",
                    //     name: "subscribedata",
                    //     title: "订阅数据",
                    //     children: [],
                    // },
                ],
            }
        ]
    },
]

export default menuArray



// WEBPACK FOOTER //
// ./src/staticData/menuArray.js